<h1 mat-dialog-title>{{ dialogTitle }}</h1>

<mat-dialog-content>
  <div *ngIf="dialogDescription" id="dialog-description">
    {{ dialogDescription }}
  </div>

  <app-filter-select [multiple]="false"
                     [optional]="false"
                     [options]="allItems"
                     [displayFn]="displayFn"
                     [label]="dropdownLabel"
                     (selectionChange)="selectedItem = $event.value ?? []">
  </app-filter-select>

</mat-dialog-content>

<mat-dialog-actions>
  <button mat-raised-button type="submit" color="primary" (click)="onSuccess()" [disabled]="!selectedItem">
    {{ 'common.buttons.ok' | transloco }}
  </button>

  <button (click)="closeDialog()" mat-raised-button type="button">
    {{ 'common.buttons.cancel' | transloco }}
  </button>

</mat-dialog-actions>
